import Vue from "vue";
import App from "./App.vue";
import { store } from "./store";

Vue.config.productionTip = false;

const block = window.document.querySelector(".genaction-map");
if (block) {
  new Vue({
    el: "#app",
    store,
    render(h) {
      return h(App);
    },
  }).$mount("#app");
}
